import React from "react";
import { services } from "../../v3/data";

const Services = () => (
  <section id="services" className="section soft rv">
    <div className="pagewrap">
      <div className="shead">
        <div>
          <div className="snum">[ 02 / SERVICES ]</div>
          <h2 className="h2">
            What I can help
            <br />
            you build.
          </h2>
        </div>
        <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
          SCOPED → BUILT → DEPLOYED
        </span>
      </div>
      <div className="svc-grid">
        {services.map((sv) => (
          <div key={sv.num} className="svc-cell stag">
            <div className="fx jb ac mb20">
              <span className="mono" style={{ fontSize: 13, fontWeight: 600, color: "var(--accent)" }}>
                {sv.num}
              </span>
              <span className="mono" style={{ fontSize: 20, color: "#CBD5E1" }}>
                {sv.glyph}
              </span>
            </div>
            <h3 style={{ fontSize: 19, fontWeight: 600, margin: "0 0 10px" }}>{sv.title}</h3>
            <p style={{ fontSize: 14.5, lineHeight: 1.7, color: "var(--muted)", margin: 0 }}>{sv.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
